import React from 'react';
import { Dimmer, Table, Loader, Icon, Popup } from 'semantic-ui-react';
import TablePaginationMenu from '../../../components/TablePaginationMenu';
import { TableData } from '../../../services/dashboard';

interface DashboardTableProps {
  tableData: TableData[];
  tableLoading: boolean;
  currentPage: number;
  setCurrentPage: (page: number) => void;
  totalItems: number;
}

const DashboardTable: React.FC<DashboardTableProps> = ({
  tableData,
  tableLoading,
  currentPage,
  setCurrentPage,
  totalItems
}) => {
  return (
    <Table singleLine>
      <Table.Header fullWidth>
        <Table.Row>
          <Table.HeaderCell textAlign="center">Franquia</Table.HeaderCell>
          <Table.HeaderCell textAlign="center">Imobiliária</Table.HeaderCell>
          <Table.HeaderCell textAlign="center">
            Apólices Emitidas/Renovadas
          </Table.HeaderCell>
          <Table.HeaderCell textAlign="center">Apólices Canceladas</Table.HeaderCell>
          <Table.HeaderCell textAlign="center">Apólices Ativas</Table.HeaderCell>
          <Table.HeaderCell textAlign="center">Prêmio Emitido</Table.HeaderCell>
          <Table.HeaderCell textAlign="center">Prêmio Faturado</Table.HeaderCell>
          <Table.HeaderCell textAlign="center">Comissão Total</Table.HeaderCell>
          <Table.HeaderCell textAlign="center">Comissão Imobiliária</Table.HeaderCell>
          <Table.HeaderCell textAlign="center">Comissão Corretora</Table.HeaderCell>
          <Table.HeaderCell textAlign="center" collapsing>
            <Popup
              content={
                <div>
                  <p>
                    <b>Seguro Fiança:</b> O período selecionado se refere a data do pedido
                    de contratação.
                  </p>
                  <p>
                    <b>Seguro Incêndio:</b> O período selecionado se refere a data do
                    pedido de contratação.
                  </p>
                  <p>
                    <b>Capitalização:</b> O período selecionado se refere a data de
                    solicitação do Título.
                  </p>
                  <p>
                    <b>Sinistros:</b> O período selecionado se refere a data da
                    solicitação do sinistro.
                  </p>
                </div>
              }
              position={'top right'}
              trigger={
                <div
                  style={{
                    cursor: 'pointer',
                    color: '#2185D0'
                  }}
                >
                  <Icon name="info circle" />
                </div>
              }
            />
          </Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Dimmer.Dimmable as={Table.Body} dimmed={tableLoading}>
        {tableLoading && (
          <Dimmer active blurring>
            <Loader />
          </Dimmer>
        )}
        {tableData.length > 0 ? (
          <>
            {tableData.map((item: TableData, index: number) => (
              <Table.Row key={index}>
                <Table.Cell textAlign="center">
                  {item.franchiseName || 'Sem Franquia'}
                </Table.Cell>
                <Table.Cell textAlign="left">{item.estateName}</Table.Cell>
                <Table.Cell textAlign="center">{item.totalIssued}</Table.Cell>
                <Table.Cell textAlign="center">{item.totalCanceled}</Table.Cell>
                <Table.Cell textAlign="center">{item.totalActive}</Table.Cell>
                <Table.Cell textAlign="center">{item.totalInvoiced}</Table.Cell>
                <Table.Cell textAlign="center">{item.totalComission}</Table.Cell>
                <Table.Cell textAlign="center">{item.totalComissionEstate}</Table.Cell>
                <Table.Cell textAlign="center">{item.totalComissionBroker}</Table.Cell>
                <Table.Cell textAlign="center" colSpan={2}>
                  {item.claims}
                </Table.Cell>
              </Table.Row>
            ))}
          </>
        ) : (
          <Table.Row>
            <Table.Cell colSpan={7} textAlign="center">
              <span>Nenhum registro encontrado</span>
            </Table.Cell>
          </Table.Row>
        )}
      </Dimmer.Dimmable>
      <Table.Footer fullWidth>
        <Table.Row>
          <Table.HeaderCell colSpan={7} textAlign="right">
            {!tableLoading && (
              <TablePaginationMenu
                currentPage={currentPage}
                dataCount={totalItems}
                setCurrentPage={setCurrentPage}
              />
            )}
          </Table.HeaderCell>
        </Table.Row>
      </Table.Footer>
    </Table>
  );
};

export default DashboardTable;
